import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'
import React, { memo } from 'react'

const CardCell = ({ value }) => {
  return (
    <Text textAlign="end" variant="body2">
      {value ? `*******${/\d{4}$/g.exec(value)}` : ''}
    </Text>
  )
}

CardCell.propTypes = {
  value: PropTypes.string,
}

export default memo(CardCell)
